// The aircraft identity doors (routes/aircraft-identity.routes.js; MAKE-MODEL-TIME-SPEC session 1). Every write is
// David's (admin_tools); the server records who and when. A model is sent by its key and shown by its name only.
import { api } from '@/lib/api.js';

const BASE = '/api/tracon/aircraft-identity';
export const getReviewList = () => api.get(`${BASE}/review`);
export const getPlacingList = () => api.get(`${BASE}/placing`);
export const getDealModels = (dealId) => api.get(`${BASE}/deal/${encodeURIComponent(dealId)}`);
export const getFamilies = () => api.get(`${BASE}/families`);
export const getCorrections = () => api.get(`${BASE}/corrections`);
export const searchModels = (q) => api.get(`${BASE}/catalog?q=${encodeURIComponent(q)}`);
export const stateTypeCorrection = (body) => api.post(`${BASE}/corrections`, body);
export const correctionImpact = (faa_model_code, model_key) => api.get(`${BASE}/corrections/impact?faa_model_code=${encodeURIComponent(faa_model_code)}&model_key=${encodeURIComponent(model_key)}`);
export const createBrokerModel = (body) => api.post(`${BASE}/broker-models`, body);
export const withdrawTypeCorrection = (code) => api.del(`${BASE}/corrections/${encodeURIComponent(code)}`);
export const stateTailModel = (body) => api.post(`${BASE}/tail-models`, body);
export const confirmTailModel = (body) => api.post(`${BASE}/tail-models/confirm`, body);
export const withdrawTailModel = (registration) => api.del(`${BASE}/tail-models/${encodeURIComponent(registration)}`);
export const createFamily = (display_name) => api.post(`${BASE}/families`, { display_name });
export const renameFamily = (id, display_name) => api.patch(`${BASE}/families/${encodeURIComponent(id)}`, { display_name });
export const removeFamily = (id) => api.del(`${BASE}/families/${encodeURIComponent(id)}`);
export const placeModel = (body) => api.post(`${BASE}/families/place`, body);
